<template>
  <div>
    <div class="content">
      <div class="content-main">
        <p class="content-title">邀请奖励<un-lock/><page-desc/></p>
        <div class="content-input">
          <div class="content-input-left">
            <div class="content-input-item">
              <label>服务类型</label>
              <el-select v-model="serviceType" placeholder="Select" class="select-item">
                <el-option v-for="item in serviceTypeArray" :key="item.serviceType" :label="item.name" :value="item.serviceType">
                </el-option>
              </el-select>
            </div>

            <div class="content-input-item">
              <DatePickerRange title="时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
            </div>
            <div class="content-input-item">
              <label>项目名称</label>
              <SearchComponents :searchTypeList="searchTypeList" :searchType="searchType"  :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
              <el-checkbox v-model="limitState" style="margin-left: 8px"><span style="white-space: nowrap">有限制</span></el-checkbox>
            </div>

            <div class="content-input-item">
              <label>启用状态</label>
              <el-select v-model="state" placeholder="Select" class="select-item">
                <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="content-input-right">
            <div class="content-input-btn">
              <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
              <!--            <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>-->
            </div>
          </div>


        </div>
      </div>
      <div class="content-main">
        <!--        <p class="content-title" style="padding-bottom: 16px;">用户权限</p>-->
        <div class="content-button">
          <div>
            <el-button type="primary" @click="editPrizeDialog(-1)" size="default">添加项目</el-button>
          </div>
          <BtnGroup :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
        </div>
        <div class="content-table">
          <el-table
              ref="multipleTableRef"
              :data="pageDataList"
              style="width: 100%; "
              v-loading="listLoading"
              size="default"
              border
          >
            <!--            <el-table-column property="id" label="ID" v-if="checkColList.indexOf('ID') > -1"/>-->
            <el-table-column property="createTime" label="创建时间" v-if="checkColList.indexOf('创建时间') > -1"/>
            <el-table-column property="" label="服务类型" v-if="checkColList.indexOf('服务类型') > -1">
              <template #default="scope">
                <p>{{scope.row.serviceType == 1?'洗澡项目':scope.row.serviceType == 2?'增值项目':scope.row.serviceType == 5?'其他':''}}</p>
              </template>
            </el-table-column>
            <el-table-column property="projectName" label="项目名称" v-if="checkColList.indexOf('项目名称') > -1"/>
            <el-table-column property="visitDay" label="回访时间" v-if="checkColList.indexOf('回访时间') > -1">
              <template #default="scope">
                {{scope.row.visitDay == -1?'无需回访':scope.row.visitDay == 0?'立即回访':scope.row.visitDay}}
              </template>
            </el-table-column>
            <el-table-column property="price" label="原价格" v-if="checkColList.indexOf('原价格') > -1"/>
            <el-table-column property="inviteNum" label="邀请人数" v-if="checkColList.indexOf('邀请人数') > -1"/>
            <el-table-column property="" label="状态" v-if="checkColList.indexOf('状态') > -1">
              <template #default="scope">
                <p :style="{color: scope.row.state == 2?'red':''}">{{scope.row.state == 0?'待启用':scope.row.state == 1?'已启用':scope.row.state == 2?'已停用':'' }}</p>
              </template>
            </el-table-column>
            <el-table-column property="orderNum" label="排序" v-if="checkColList.indexOf('排序') > -1"/>
            <el-table-column label="操作" v-if="checkColList.indexOf('操作') > -1">
              <template #default="scope">
                <el-button @click="editPrizeDialog(scope.$index,scope.row)" size="small" type="primary">编辑</el-button>
                <el-button v-if="scope.row.state == 1" @click="updateState(scope.row, 2)" size="small" type="warning" v-loading="scope.row.updateLoading">停用</el-button>
                <el-button v-if="scope.row.state == 0 || scope.row.state == 2" @click="updateState(scope.row, 1)" size="small" type="success" v-loading="scope.row.updateLoading">开启</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { getFormData, postFormData } from "@/api/api";
import { getInvitePrizePageList, updateInvitePrizeState, listProjectServiceType} from "@/api/url";
import ProjectDialog from "../project/components/ProjectDialog";
import Dialog from "@/assets/js/dialog"
import BtnGroup from '../../components/BtnGroup'
import SearchComponents from "@/components/SearchComponents";
import unLock from "@/layout/components/unLock";
import DatePickerRange from "@/components/DatePickerRange";
import PrizeDialog from "@/views/invite/components/PrizeDialog";

export default {
  name: "InvitePrize",
  components: { BtnGroup, SearchComponents, unLock, DatePickerRange},
  data() {
    return {
      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,
      updateLoading: false,

      shopIdArray: [
        {name: '不限', id: -1},
      ],
      shopIdArr:[],
      shopId: -1,


      stateArray: [
        {label: '不限', value: -1},
        {label: '待启用', value: 0},
        {label: '已启用', value: 1},
        {label: '已停用', value: 2}
      ],
      state: -1,

      //刷新组
      colList: ['创建时间', '服务类型',  '项目名称', '回访时间', '原价格',  '邀请人数', '状态', '排序', '操作'],
      checkColList: [],

      //搜索
      searchTypeList: [
        {label : '项目名称', value : 1},
      ],
      searchType: 1,
      searchValue: '',

      serviceTypeArray: [
        {name: '不限', serviceType: -1}
      ],
      serviceTypeList: [],
      serviceType: -1,

      //时间
      startTime: '',
      endTime: '',
      isChecked: true,

      limitState: true,

    }
  },
  methods: {

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },

    getSearchType(e) {
      this.searchType = e;
    },
    getSearchValue(e) {
      this.searchValue = e;
    },

    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['state'] = this.state;
      param['serviceType'] = this.serviceType;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['limitState'] = this.limitState?1:0;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getInvitePrizePageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    formatTime(time) {
      let timestamp = time
      let newDate = new Date(parseInt(timestamp))
      let y = newDate.getFullYear();
      let m = newDate.getMonth()+1;
      let d = newDate.getDate();
      return  y + '-' + (m<10?'0'+m:m) + '-' + (d<10?'0'+d:d)
    },

    editPrizeDialog(idx, row) {
      let _title = '';
      let prizeForm = {}
      if (idx > -1) {
        _title = '编辑邀请奖励'
        prizeForm = Object.assign({}, row);
        // console.log(projectForm)
      }else {
        _title = '添加邀请奖励'
        // console.log(projectForm)
      }
      Dialog.open({
        title: _title,
        component: PrizeDialog,
        data: {
          prizeForm: prizeForm,
          serviceTypeList: this.serviceTypeList,
          ids: idx,
          width: '500px',
        },
        confirm: (result) => {
          this.getPage()
        }
      })
    },


    updateState(row, state) {
      row.updateLoading = true;
      let param = {};
      param['id'] = row.id;
      param['state'] = state;
      postFormData(updateInvitePrizeState, param).then((data)=>{
        let {code, msg} = data;
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'success'
          })
          row.state = state
        }else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        row.updateLoading = false;
      }).catch(()=> {
        row.updateLoading = false;
      })
    },

    getServiceType() {
      getFormData(listProjectServiceType).then((data) => {
        if(data.code == 200) {
          this.serviceTypeList = data.data.filter(item => item.serviceType == 1 ||　item.serviceType == 2 || item.serviceType == 5　)
          this.serviceTypeArray = this.serviceTypeArray.concat(this.serviceTypeList)
        }
      })
    }


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getServiceType()
    this.getPage();
    // this.getShopList()
  }
}
</script>

<style scoped>
/*.el-table {*/
/*  --el-table-header-bg-color: #ffffff !important;*/
/*}*/
</style>
